import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { Page404Component } from './extrapages/page404/page404.component';
import { RespuestaPagoEcommerceComponent } from './shared/ui/respuesta-pago-ecommerce/respuesta-pago-ecommerce.component';
import { CambioContrasenaComponent } from './shared/ui/cambio-contrasena/cambio-contrasena.component';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'web', loadChildren: () => import('./web/web.module').then(m => m.WebModule) },
  { path: 'respuesta-pago', component: RespuestaPagoEcommerceComponent },
  { path: 'reset-password', component: CambioContrasenaComponent },

  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule), canActivate: [AuthGuard] },
  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
